import type { I18nFn } from '#/i18n/types/I18nFn';

export enum LocationType {
  ONSITE = 'ONSITE',
  HYBRID = 'HYBRID',
  REMOTE = 'REMOTE',
}

export const LOCATION_TYPE = (i18n: I18nFn) =>
  ({
    // TRANSLATORS: listing location type
    [LocationType.ONSITE]: i18n('On-site'),
    // TRANSLATORS: listing location type
    [LocationType.HYBRID]: i18n('Hybrid'),
    // TRANSLATORS: listing location type
    [LocationType.REMOTE]: i18n('Remote'),
  }) satisfies Record<LocationType, string>;

export const LOCATION_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(LOCATION_TYPE(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const LOCATION_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(LOCATION_TYPE(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
